import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING, VIEW } from "const"
import { StateType, hasAccess, deepCopy } from "client/utils"
import {
    PRM_OKR_OBJECTIVE_KEY_RESULT,
    StoreType,
    OkrObjectiveProps,
    OkrObjectiveList,

    LoadOkrObjectiveById,
    IsOwnerOkrObjective,

    setOkrObjectiveList,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import AccessDenied from "client/parts/accessDenied"
import NotFound from "client/parts/notFound"
import KeyResults from "client/pages/okr/keyResult/list"
import { ObjectiveLayout } from "client/pages/okr/styled"
import Form from "./form"
import ObjectiveComments from "./comments"

// "View" page can be opened from objective list and from parent link.
// So, several "View" pages can be opened at the same time. And current "objectiveView" cannot be stored on Redux Store level
const ObjectiveView = ({
    sessionId,
    objectiveId,
}: OkrObjectiveProps) => {
    const session = useSelector((state: StoreType) => state.okrSession.sessionView)
    const objectiveList = useSelector((state: StoreType) => state.okrObjective.objectiveList)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        setLoadState(PENDING)
        LoadOkrObjectiveById(objectiveId, sessionId).then((res) => {
            const objectiveListCopy: OkrObjectiveList = deepCopy(objectiveList)
            objectiveListCopy[objectiveId] = res
            dispatch(setOkrObjectiveList(objectiveListCopy))
            setLoadState(IDLE)
        })
    }, [])

    const objective = objectiveList[objectiveId] || null

    const isOwnerObjective = IsOwnerOkrObjective(objective, userData.userId)
    const isOwnerSession = session.owner === userData.userId
    const isOwner = isOwnerObjective || isOwnerSession

    const viewAccess = hasAccess(PRM_OKR_OBJECTIVE_KEY_RESULT, VIEW)
    const allowedToView = viewAccess || isOwner

    if (!allowedToView) return <AccessDenied />
    if (!objective) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{objective.title}</PageTitle>
            </PageHeader>
            <PageContent>
                {
                    loadState === PENDING
                    && <Loader />
                }
                <ObjectiveLayout>
                    <Form objective={objective} />
                    <KeyResults objective={objective} />
                    <ObjectiveComments objective={objective} />
                </ObjectiveLayout>
            </PageContent>
        </Container>
    )
}
export default ObjectiveView
